import React from 'react';

export const NewBoardIcon = ({ width = 18, height = 16, color = '#fff' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1667 4.99999H4.16667V13.3333H10.8333V15H2.5V3.33333H15.8333V9.99999H14.1667V4.99999Z"
      fill={color}
    />
    <path
      d="M14.1667 11.6667H15.8333V13.3333H17.5V15H15.8333V16.6667H14.1667V15H12.5V13.3333H14.1667V11.6667Z"
      fill={color}
    />
    <path d="M8.33333 6.66666H5.83333V11.6667H8.33333V6.66666Z" fill={color} />
    <path
      d="M11.25 9.16666C11.9404 9.16666 12.5 8.60702 12.5 7.91666C12.5 7.22631 11.9404 6.66666 11.25 6.66666C10.5596 6.66666 10 7.22631 10 7.91666C10 8.60702 10.5596 9.16666 11.25 9.16666Z"
      fill={color}
    />
  </svg>
);
